import { ImpactGauge } from "components/impact-gauge";
import { useStore } from "hooks/use-store";
import { EcoGauge } from "components/eco-gauge";
import { EcoGaugeRpm } from "components/eco-gauge-rpm";
import { FuelRateGauge } from "components/fuel-rate-gauge";
import { PeakImpactStat } from "../stats/peak-impact";
import { FuelSavingsStat } from "../stats/fuel-savings";
import { RpmSogMode } from "types/enums";

export const EcoGauges = () => {
  const rpmSogMode = useStore((state) => state.rpmSogMode);

  return (
    <div className="flex w-full h-full pb-6">
      <div className="h-full w-[25%] flex flex-col items-center justify-center">
        <div className="w-full h-[18%] shrink-0"></div>
        <div className="flex-1 w-full overflow-hidden">
          <ImpactGauge />
        </div>
        <div className="w-full h-[18%] shrink-0">
          <PeakImpactStat />
        </div>
      </div>
      <div className="relative h-full w-[50%] flex items-center justify-center">
        {rpmSogMode === RpmSogMode.Sog ? <EcoGauge /> : <EcoGaugeRpm />}
      </div>
      <div className="h-full w-[25%] flex flex-col items-center justify-center">
        <div className="w-full h-[18%] shrink-0"></div>
        <div className="flex-1 w-full overflow-hidden">
          <FuelRateGauge />
        </div>
        <div className="w-full h-[18%] shrink-0 ">
          <FuelSavingsStat />
        </div>
      </div>
    </div>
  );
};
